export class TrackBuffering {
  constructor (dependencies) {
    this.getInterval = dependencies.getInterval;
    this.dispatch = dependencies.dispatch;
    this.construct = dependencies.construct;
  }

  #started = false;
  #startAt = null;

  start (startAt = Date.now()) {
    if (this.#started) {
      return;
    }

    this.#startAt = startAt;
    this.#started = true;

    this.#start();
    this.#continue(this.getInterval());
  }

  stop () {
    if (this.#started) {
      this.#finish();
    }
    clearTimeout(this.timer);
    this.#started = false;
    this.#startAt = null;
  }

  #start () {
    const metData = this.construct();
    this.dispatch('start', metData);
  }

  #continue (timeout) {
    const next = (nextTimeout) => {
      const metData = this.#withDuration(this.construct());
      this.dispatch('continue', metData);
      this.#continue(nextTimeout);
    };
    this.timer = setTimeout(next, timeout, this.getInterval(timeout));
  }

  #finish () {
    const metData = this.#withDuration(this.construct());
    this.dispatch('finish', metData);
  }

  #withDuration (metData) {
    Object.assign(metData.player, {
      buffering_duration: this.#bufferingDuration,
    });
    return metData;
  }

  get #bufferingDuration () {
    const now = Date.now();
    let bufferingDuration = Math.ceil((now - this.#startAt) / 100) * 100;
    // чому так? ні чому «донт сенд дурейшн овер 1М», а чому так сталось?
    //MHP-1398
    if (bufferingDuration > 1000000) {
      bufferingDuration = 0;
    }
    return bufferingDuration;
  }
}
